module.exports = __webpack_public_path__ + "img/g矩形 86@1x.3e20736a.png";